/** Group-tours mobile filter sheet — shared with marketplace mobile modal */
export const groupTourFilterSectionTitleClass =
  "bg-gray-blue-100 app-container mb-0 block py-3 text-lg font-bold text-gray-900 capitalize";

export const groupTourFilterRowClass =
  "app-container hover:bg-gray-blue-50 flex cursor-pointer items-center justify-between px-5 py-3";

export const groupTourFilterLabelClass =
  "font-family-body text-lg font-medium text-gray-900";

export const groupTourFilterCheckboxClass =
  "h-5 w-5 cursor-pointer rounded-sm border border-gray-400 data-[state=checked]:border-brand-500 data-[state=checked]:bg-brand-500 data-[state=checked]:text-white";

/** Shared marketplace filter chip / button styles — aligned with app cards & CTAs */

export const filterChipInactiveClass =
  "inline-flex w-max max-w-none shrink-0 cursor-pointer items-center whitespace-nowrap rounded-full border border-gray-blue-100 bg-gray-blue-100 px-3 py-1.5 text-sm font-semibold text-gray-700 transition-colors hover:border-gray-blue-200 hover:bg-gray-blue-50 md:px-4 md:py-2";

export const filterChipActiveClass =
  "inline-flex w-max max-w-none shrink-0 cursor-pointer items-center whitespace-nowrap rounded-full border border-brand-500 bg-white px-3 py-1.5 text-sm font-semibold text-brand-700 ring-1 ring-brand-500/15 transition-colors hover:bg-gray-blue-50 md:px-4 md:py-2";

/** Removable applied-filter chip (modal + filter bar) */
export const filterAppliedChipClass =
  "inline-flex w-max max-w-none shrink-0 cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-brand-500 bg-white px-3 py-1.5 text-sm font-semibold text-brand-700 ring-1 ring-brand-500/15 transition-colors hover:bg-gray-blue-50";

export const filtersButtonInactiveClass =
  "flex shrink-0 cursor-pointer items-center gap-2 rounded-lg border border-brand-500 px-4 py-2 text-sm font-semibold text-brand-700 transition-colors hover:bg-gray-blue-50";

export const filtersButtonActiveClass =
  "flex shrink-0 cursor-pointer items-center gap-2 rounded-lg border border-brand-500 bg-bg-brand-solid px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-bg-brand-solid-hover";

export const filterCheckboxClass =
  "h-5 w-5 rounded-sm border-gray-400 data-[state=checked]:border-brand-500 data-[state=checked]:bg-brand-500 data-[state=checked]:text-white";

export const filterPrimaryButtonClass =
  "cursor-pointer rounded-full bg-bg-brand-solid px-5 py-2 text-sm font-bold text-white transition-colors hover:bg-bg-brand-solid-hover";

/** Date picker from / to pills (mobile sheet) */
export const filterDatePillActiveClass =
  "cursor-pointer border-brand-500 bg-white ring-1 ring-brand-500/15";

export const filterDatePillInactiveClass =
  "cursor-pointer border-gray-blue-100 bg-gray-blue-100 text-gray-700 hover:border-gray-blue-200 hover:bg-gray-blue-50";

/** Calendar day hover (single + range pickers) */
export const filterCalendarDayHoverClass =
  "cursor-pointer hover:bg-gray-blue-100 active:bg-gray-blue-100";

/** Unselectable days — visible gray, not faded out */
export const filterCalendarDayDisabledClass =
  "cursor-not-allowed bg-gray-blue-100 text-gray-500 hover:bg-gray-blue-100 active:bg-gray-blue-100";

/** Calendar month navigation */
export const filterCalendarNavButtonClass =
  "flex size-10 shrink-0 cursor-pointer items-center justify-center rounded-full border border-gray-200 bg-white text-gray-700 transition-colors hover:bg-gray-50";

/** In-range days between start and end (desktop range calendar) */
export const filterCalendarRangeMiddleClass = "bg-brand-25";

/** Mobile sheet calendar — plain numbers, no cell boxes */
export const filterMobileCalendarDayClass =
  "text-sm font-medium text-gray-600";

/** Matches desktop range calendar start/end (MarketplaceRangeCalendar) */
export const filterMobileCalendarDaySelectedClass =
  "rounded-md bg-brand-500 text-sm font-semibold text-white shadow-none hover:bg-brand-600";

export const filterMobileCalendarDayDisabledClass =
  "cursor-not-allowed text-sm text-gray-300";

export const filterMobileDateFieldActiveClass = "text-brand-700";

export const filterMobileDateFieldInactiveClass = "text-gray-600";

/** Mobile date sheet — default field shell (white surface, same as filter chips when idle) */
export const filterMobileDateFieldCardBase =
  "rounded-xl border border-gray-blue-200 bg-white px-3 py-2";

/** Mobile date sheet — active step (same outline as filterChipActive / filterDatePillActive) */
export const filterMobileDateFieldCardActive =
  "rounded-xl border border-brand-500 bg-white px-3 py-2 ring-1 ring-brand-500/15";

/** Mobile date sheet — completed or idle step (same shell as base; state shown via label/value color) */
export const filterMobileDateFieldCardFilled = filterMobileDateFieldCardBase;

export const filterMobileDateFieldCardInactive = filterMobileDateFieldCardBase;
